import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MarkdownComponent } from 'ngx-markdown';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { AccordionModule, IconComponent } from '@pure/hive';
import { IChatSection } from '../../../data/services/copilot.service';

/**
 * Maps the RAG status emoji carried in the section data to a semantic style for
 * the header status dot. Presentation only: the emoji stays in `section.status`
 * (and in the section body); it is just rendered as a themed dot instead of a
 * raw emoji glyph, which varies in shape and color across OS/browser.
 */
const STATUS_DOT_CLASSES: Record<string, string> = {
    '🔴': 'status-major',
    '🟡': 'status-warning',
    '🟢': 'status-success',
};

/**
 * Renders answer sections as collapsible Hive accordion panels. Panels are expanded
 * while the response is still streaming (isLoading) so content is visible as it
 * arrives, then collapse once generation completes. Renders nothing when there are
 * no sections, so it only appears for responses that emit section markers.
 */
@Component({
    selector: 'copilot-collapsible-sections',
    standalone: true,
    imports: [AccordionModule, IconComponent, MarkdownComponent],
    templateUrl: './collapsible-sections.component.html',
    styleUrl: './collapsible-sections.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsibleSectionsComponent {
    @Input() sections: IChatSection[] = [];
    @Input() isLoading = false;

    protected readonly faChevronDown = faChevronDown;

    protected statusDotClass(status: string): string {
        return STATUS_DOT_CLASSES[status] ?? '';
    }
}
